// extracted by mini-css-extract-plugin
module.exports = {"legalModal":"LegalModal_legalModal__sBcmW","legalBody":"LegalModal_legalBody__iGGI4","legalFooter":"LegalModal_legalFooter__oIlra"};